/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_ColorInputs */

const en_case_field_color = /** @type {(inputs: Case_Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const pt_br2_case_field_color = /** @type {(inputs: Case_Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Case_Field_ColorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_color = /** @type {((inputs?: Case_Field_ColorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_ColorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_color(inputs)
	return pt_br2_case_field_color(inputs)
});